app.service('warrantyModal', function(productCardConfig, modal, broker) {
	let $modal;
	let selectedWarrantyPaymentType;
	let selectedWarrantyPaymentPeriod;
	let selectedWarrantyId;

	function getModal(warrantyId, outletCategoryId) {
		return load(warrantyId, outletCategoryId)
			.then(data => generate(data, warrantyId))
			.fail(() => modal.alert('Bład pobierania modala.'));
	}

	function load(warrantyId, outletCategoryId) {
		const productId = productCardConfig.getData().id;

		return $.ajax({
			url: '/warranty-front-view.ltr',
			data: {
				outletCategoryId,
				warrantyId,
				productId
			}
		});
	}

	function generate(data, warrantyId) {
		const modalId = `modal-${warrantyId}`;

		if (modal.isExist(modalId)) {
			modal.destroy(modalId);
		}

		return modal.generate({
			id: modalId,
			content: data,
			cssClass: 'warranty-item'
		});
	}

	function selectActiveWarranty() {
		const $selectedWarranty = $('.js-add-warranty-checkbox:checked');

		const warrantyId = $selectedWarranty.val();

		const warrantyPaymentType = $selectedWarranty.data('warranty-payment-type');

		$modal
			.find('.js-add-warranty-checkbox')
			.filter(`[data-warranty-payment-type=${warrantyPaymentType}]`)
			.filter(`[value=${warrantyId}]`)
			.prop('checked', true);
	}

	function showSelectedWarrantyPaymentType() {
		const $modalWarrantyList = $modal.find('.warranty-info-modal');
		const $selectedWarranty = $modalWarrantyList.filter(
			`[data-warranty-type=${selectedWarrantyPaymentType}]`
		);

		$selectedWarranty.addClass('is-visible').removeClass('is-hidden');

		$modalWarrantyList
			.not($selectedWarranty)
			.addClass('is-hidden')
			.removeClass('is-visible');

		updatePaymentTypeSelector();
	}

	function updatePaymentTypeSelector() {
		$modal
			.find('.select3-input')
			.val(`${selectedWarrantyPaymentType}|${selectedWarrantyPaymentPeriod}`)
			.change();
	}

	function uncheckSelectedWarranty() {
		$('.js-add-warranty-radio')
			.filter(':checked')
			.prop('checked', false);
	}

	function setSelectedWarrantyPaymentTypeAndPeriod(data) {
		selectedWarrantyPaymentType = data[0];
		selectedWarrantyPaymentPeriod = data[1];
	}

	function handleWarrantyPaymentTypeChange() {
		const data = $(this)
			.val()
			.split('|');

		setSelectedWarrantyPaymentTypeAndPeriod(data);

		uncheckSelectedWarranty();

		showSelectedWarrantyPaymentType();

		selectActiveWarranty();

		broker.trigger('WARRANTY_PAYMENT_TYPE_CHANGE', [
			selectedWarrantyPaymentType,
			selectedWarrantyId,
			selectedWarrantyPaymentPeriod
		]);
	}

	function setModalEvents() {
		$modal
			.find('.select3-input')
			.on('selectOption', handleWarrantyPaymentTypeChange);
	}

	function show(
		warrantyId,
		warrantyPaymentType,
		outletCategoryId,
		warrantyPeriod
	) {
		selectedWarrantyPaymentType = warrantyPaymentType;
		selectedWarrantyId = warrantyId;
		selectedWarrantyPaymentPeriod = `${warrantyPeriod}_${selectedWarrantyId}`;

		getModal(warrantyId, outletCategoryId).then(initModal);
	}

	function initModal(modalHandler) {
		$modal = modalHandler.$modal;

		$modal.find('.select3-container input').select3();

		setModalEvents();

		showSelectedWarrantyPaymentType();

		selectActiveWarranty();
	}

	return {
		show
	};
});